import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RetrieveQuoteFlow } from 'types/enums';
import { PaymentSchedule } from 'types/payments';
import { PolicyResponse } from 'types/policy';
import { Nullable } from 'types/utils';

export interface Quote {
  paymentSchedule: PaymentSchedule;
  levelOfExcess: number;
  quoteNumber?: string;
  policyNumber?: string;
  accessToken?: string;
  /** @Todo Remove premiums API response and only store the transformations we need from it. I.e clauses, premium values etc. */
  premiums: PolicyResponse;
  quoteDateUpdated: boolean;
  quoteRetrievalError: boolean;
  retrieveQuoteFlow?: RetrieveQuoteFlow;
}

const initialState: Nullable<Quote> = {
  paymentSchedule: PaymentSchedule.Yearly,
  levelOfExcess: 500,
  quoteNumber: null,
  policyNumber: null,
  accessToken: null,
  premiums: null,
  quoteDateUpdated: false,
  quoteRetrievalError: false,
  retrieveQuoteFlow: null,
};

export const quoteSlice = createSlice({
  name: 'quote',
  initialState,
  reducers: {
    /*
     * Redux Toolkit allows us to write "mutating" logic in reducers. It doesn't actually mutate the state
     * because it uses the Immer library, which detects changes to a "draft state" and produces a brand new
     * immutable state based off those changes
     */
    updatePaymentSchedule: (state, action: PayloadAction<PaymentSchedule>) => {
      state.paymentSchedule = action.payload;
    },
    updateLevelOfExcess: (state, action: PayloadAction<number>) => {
      state.levelOfExcess = action.payload;
    },
    updateQuoteNumber: (state, action: PayloadAction<string | null>) => {
      state.quoteNumber = action.payload;
    },
    updatePolicyNumber: (state, action: PayloadAction<string | null>) => {
      state.policyNumber = action.payload;
    },
    updateAccessToken: (state, action: PayloadAction<string | null>) => {
      state.accessToken = action.payload;
    },
    updatePremiums: (state, action: PayloadAction<PolicyResponse | null>) => {
      state.premiums = action.payload;
    },
    updateQuoteDateUpdated: (state, action: PayloadAction<boolean>) => {
      state.quoteDateUpdated = action.payload;
    },
    updateQuoteRetrievalError: (state, action: PayloadAction<boolean | null>) => {
      state.quoteRetrievalError = action.payload;
    },
    updateRetrieveQuoteFlow: (state, action: PayloadAction<RetrieveQuoteFlow>) => {
      state.retrieveQuoteFlow = action.payload;
    },
  },
});

/* Fully typed Action creators are automagically generated for each case reducer function */
export const {
  updatePaymentSchedule,
  updateLevelOfExcess,
  updatePremiums,
  updateQuoteNumber,
  updatePolicyNumber,
  updateQuoteDateUpdated,
  updateQuoteRetrievalError,
  updateAccessToken,
  updateRetrieveQuoteFlow,
} = quoteSlice.actions;

export default quoteSlice.reducer;
